import { render, staticRenderFns } from "./ImportFilesDialog.vue?vue&type=template&id=1b060d37"
import script from "./ImportFilesDialog.vue?vue&type=script&lang=js"
export * from "./ImportFilesDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportFilesDialog.vue?vue&type=style&index=0&id=1b060d37&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports